import React from 'react';
import classNames from 'classnames';
import { ListingCard } from '../../../components';

import css from './Sections.module.css';
import Icons from '../../../components/Icons/Icons';

function ExploreSection(props) {
  const { listings = [], intl } = props;

  const t = id => intl.formatMessage({ id });

  return (
    <div className={classNames(css.popularSessions, css.sectionPadding, css.justInSec)}>
      <div className={css.fixedWidthContainer}>
        <h1 className={css.heading} aria-label={t('ExploreSection.recentlySold')}>
          {t('ExploreSection.recentlySold')} <Icons name="rightArrow" />
        </h1>

        <div className={css.sectionListings}>
          <div className={css.customSlider}>
            {listings.map(l => (
              <ListingCard
                className={css.listingCard}
                key={l?.id?.uuid}
                listing={l}
                setActiveListing={() => {}}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExploreSection;
